import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function getMenuSuccess(menu) {
  return {type: types.SET_MENU_SUCCESS, datos:menu};
}



export function getMenu(token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().MenuApi.getMenu(  token).then(menu => {                  
                  dispatch(getMenuSuccess(menu));
                  
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setMenu(menu){
	return {type: types.SET_MENU_SUCCESS, datos:menu};
}
